import React from 'react';
import { Modal } from '@components/molecules/Modal';
import { EvidenceCaptureRef } from '@services/evidenceSlot';

interface EvidenceLightboxProps {
  capture: EvidenceCaptureRef | null;
  onClose: () => void;
}

/**
 * Sprint 11, story-042 (U77). Full-size image + metadata on click, built on the existing
 * `molecules/Modal`, per docs/ux/story-042-design.md.
 */
export const EvidenceLightbox: React.FC<EvidenceLightboxProps> = ({ capture, onClose }) => {
  if (!capture) return null;

  return (
    <Modal title="Evidence capture" isOpen={Boolean(capture)} onClose={onClose} size="medium">
      {capture.dispositionType ? (
        // Sprint 12, story-051 (U72). Text-only mode, parallel to the existing no-thumbnail
        // FAILED render below — web has no camera and cannot change the disposition.
        <div className="text-sm text-blue-700 dark:text-blue-400">
          <p className="font-medium">Disposition: {capture.dispositionType.replace('_', ' ')}</p>
          {capture.dispositionReason && <p className="mt-1">&quot;{capture.dispositionReason}&quot;</p>}
        </div>
      ) : capture.deliveryStatus === 'FAILED' || !capture.thumbnailUrl ? (
        <p className="text-sm text-amber-600 dark:text-amber-400">
          Upload attempted {new Date(capture.capturedAt).toLocaleString()}, did not complete.
        </p>
      ) : (
        <img src={capture.thumbnailUrl} alt="Evidence capture" className="w-full rounded-md" />
      )}
      <div className="mt-3 text-sm text-frozenGrayShades6 dark:text-frozenGrayShades4">
        <p>{new Date(capture.capturedAt).toLocaleString()}</p>
        {capture.capturedByName && <p>Captured by {capture.capturedByName}</p>}
        {capture.captureChannel && <p>Channel: {capture.captureChannel}</p>}
      </div>
    </Modal>
  );
};

export default EvidenceLightbox;
